// 首页视频配置文件
// 集中管理所有首页相关的视频URL和配置

export interface VideoConfig {
  url: string;
  opacity?: number;
  aspectRatio?: "16:9" | "9:16" | "1:1";
  poster?: string;
}

export interface HomepageVideoConfig {
  hero: {
    video: VideoConfig;
  };
  features: {
    textToVideo: {
      video: VideoConfig;
    };
    imageToVideo: {
      video: VideoConfig;
    };
    textToImage: {
      video: VideoConfig;
    };
    imageToImage: {
      video: VideoConfig;
    };
  };
  cta: {
    sampleVideo: VideoConfig;
  };
}

// 首页视频配置
export const homepageVideos: HomepageVideoConfig = {
  hero: {
    video: {
      url: "https://cdn.wan27ai.co/wan2.2/1.mp4",
      opacity: 70,
      aspectRatio: "16:9"
    }
  },
  features: {
    textToVideo: {
      video: {
        url: "https://cdn.wan27ai.co/wan2.2/3.mp4",
        aspectRatio: "9:16"
      }
    },
    imageToVideo: {
      video: {
        url: "https://cdn.wan27ai.co/wan2.2/2.mp4",
        aspectRatio: "9:16"
      }
    },
    textToImage: {
      video: {
        url: "https://cdn.wan27ai.co/wan2.2/4.mp4",
        aspectRatio: "9:16"
      }
    },
    imageToImage: {
      video: {
        url: "https://cdn.wan27ai.co/wan2.2/5.mp4",
        aspectRatio: "9:16"
      }
    }
  },
  cta: {
    sampleVideo: {
      url: "https://cdn.wan27ai.co/video/550171f8-3109-4bcc-8439-4e243d084538.mp4",
      aspectRatio: "16:9"
    }
  }
};

// 获取特定视频配置的辅助函数
export const getHeroVideo = () => homepageVideos.hero.video;
export const getFeatureVideo = (feature: keyof HomepageVideoConfig['features']) => homepageVideos.features[feature].video;
export const getCTASampleVideo = () => homepageVideos.cta.sampleVideo;

// 获取所有视频URL的列表（用于预加载）
export const getAllVideoUrls = (): string[] => {
  const urls: string[] = [];

  // Hero视频
  urls.push(homepageVideos.hero.video.url);

  // 特性视频
  Object.values(homepageVideos.features).forEach(feature => {
    urls.push(feature.video.url);
  });

  // CTA示例视频
  urls.push(homepageVideos.cta.sampleVideo.url);

  return urls;
};

// 默认视频URL（备用）
export const DEFAULT_VIDEO_URL = "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4";

// 视频预加载配置
export const videoPreloadConfig = {
  hero: {
    priority: 'high' as const,
    preload: 'auto' as const
  },
  features: {
    priority: 'medium' as const,
    preload: 'metadata' as const
  },
  cta: {
    priority: 'low' as const,
    preload: 'metadata' as const
  }
}; 